import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './app/environments/environment';

const originTrialToken = environment.ORIGIN_TRIAL_TOKEN.USER_MEDIA_ELEMENT;
if (originTrialToken) {
  const originTrialMeta = document.querySelector('meta[http-equiv="origin-trial"]');
  originTrialMeta?.setAttribute('content', originTrialToken);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
